/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Table_EndpointInputs */

const en_platform_table_endpoint = /** @type {(inputs: Platform_Table_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

const zh_hans1_platform_table_endpoint = /** @type {(inputs: Platform_Table_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`接口`)
};

const pt_br2_platform_table_endpoint = /** @type {(inputs: Platform_Table_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

const es_platform_table_endpoint = /** @type {(inputs: Platform_Table_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

const fr_platform_table_endpoint = /** @type {(inputs: Platform_Table_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

const de_platform_table_endpoint = /** @type {(inputs: Platform_Table_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

const ru_platform_table_endpoint = /** @type {(inputs: Platform_Table_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Эндпоинт`)
};

const it_platform_table_endpoint = /** @type {(inputs: Platform_Table_EndpointInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Endpoint`)
};

/**
* | output |
* | --- |
* | "Endpoint" |
*
* @param {Platform_Table_EndpointInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const platform_table_endpoint = /** @type {((inputs?: Platform_Table_EndpointInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Table_EndpointInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_platform_table_endpoint(inputs)
	if (locale === "pt-BR") return pt_br2_platform_table_endpoint(inputs)
	if (locale === "es") return es_platform_table_endpoint(inputs)
	if (locale === "fr") return fr_platform_table_endpoint(inputs)
	if (locale === "de") return de_platform_table_endpoint(inputs)
	if (locale === "ru") return ru_platform_table_endpoint(inputs)
	if (locale === "it") return it_platform_table_endpoint(inputs)
	return en_platform_table_endpoint(inputs)
});